import type React from 'react';

import { Box, Heading, List, TextButton } from '@zillow/constellation-10';

import type { EnteredValue } from '../../../shared/models/Summary';
import SummaryItem from './SummaryItem';

type OwnProps = {
  showEditLink: boolean;
  enteredValue: EnteredValue;
  getLeasingStatusForNode(nodeId: number): void;
  sectionCategory: string;
};

export function FieldRow({ getLeasingStatusForNode, enteredValue, showEditLink }: OwnProps): JSX.Element {
  function getLeasingStatus(event: React.SyntheticEvent<HTMLSpanElement>): void {
    const { associatedNodeId } = event.currentTarget.dataset;
    getLeasingStatusForNode(Number(associatedNodeId));
  }

  function renderFieldValue(enteredValue: EnteredValue): React.ReactNode {
    if (enteredValue.fieldValues && enteredValue.fieldValues.length) {
      const needsInfoIndexes = enteredValue.needsInfo || [];
      return (
        <List.Root appearance="none">
          {enteredValue.fieldValues.map((fieldValue, index) => (
            <SummaryItem
              key={index}
              needsInfo={needsInfoIndexes.indexOf(index) !== -1}
              associatedNodeId={enteredValue.associatedNodeId}
              getLeasingStatusForNode={getLeasingStatus}
            >
              {fieldValue}
            </SummaryItem>
          ))}
        </List.Root>
      );
    }
  }

  return (
    <Box data-test="summary-line" css={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: 'tighter' }}>
      <Box css={{ gridColumnEnd: { base: 'span 12', md: 'span 4' } }}>
        <Heading
          level={4}
          css={{
            textStyle:
              'responsive.body-lg-bold' /* oxlint-disable-line constellation/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
          }}
          data-test="section-label"
        >
          {enteredValue.fieldDisplayName}
        </Heading>
      </Box>
      <Box css={{ gridColumnEnd: { base: 'span 12', md: 'span 7' } }}>
        <div data-test="section-values">{renderFieldValue(enteredValue)}</div>
      </Box>
      <Box css={{ gridColumnEnd: { base: 'span 12', md: 'span 1' }, justifySelf: { base: 'start', md: 'end' } }}>
        {showEditLink && (
          <TextButton
            tone="brand"
            data-test="getLeasingStatusForNode"
            data-associated-node-id={enteredValue.associatedNodeId}
            onClick={getLeasingStatus}
          >
            Edit
          </TextButton>
        )}
      </Box>
    </Box>
  );
}

export default FieldRow;
